module.exports = __webpack_public_path__ + "img/face.f17f99a3.svg";